export const GET_HEATMAP_REQUEST = 'GET_HEATMAP_REQUEST'
export const GET_HEATMAP_SUCCESS = 'GET_HEATMAP_SUCCESS'
export const GET_HEATMAP_FAILURE = 'GET_HEATMAP_FAILURE'